import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Data } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

import { TranslateService } from '@ngx-translate/core';

import { Constantes } from '../../../shared/constantes';

import { Mensaje } from '../../../shared/models/mensaje';
import { DetalleSolicitud } from '../../../shared/models/detalle-solicitud';
import { InformacionAdicional } from '../../../shared/models/informacion-adicional';
import { Log } from '../../../shared/models/log';
import { TransaccionPse } from '../../../shared/models/transaccion-pse';

import { DetalleInternoService } from '../../services/detalle-interno.service';

import { AutenticacionService } from '../../../shared/services/autenticacion.service';
import { AlertaService } from '../../../shared/components/alerta/alerta.service';
import { SpinnerService } from '../../../shared/components/spinner/spinner.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SolicitudService } from '../../../public/services/solicitud.service';

@Component({
  selector: 'app-detalle-runt',
  templateUrl: './detalle-runt.component.html',
  styleUrls: ['./detalle-runt.component.css']
})
export class DetalleRuntComponent implements OnInit {
  detalle: DetalleSolicitud;
  transaccionesPse: TransaccionPse[];
  solicitudPaga: boolean = false;
  page: number = 1;

  constructor(private translate: TranslateService,
    private autenticacionService: AutenticacionService,
    private detalleInternoService: DetalleInternoService,
    private alertaService: AlertaService,
    private spinnerService: SpinnerService,
    private activatedRoute: ActivatedRoute,
    private solicitudService: SolicitudService,
    private router: Router) { }

  ngOnInit() {
    this.spinnerService.show();

    this.activatedRoute.data
      .subscribe(
      (data: Data) => {
        var respuesta = data['detalleSolicitud'];

        if (respuesta.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
          this.detalle = respuesta.object;

          this.esSolicitudPaga();

          if (respuesta.mensaje) {
            this.alertaService.success(respuesta.mensaje);
          }
        } else {
          this.alertaService.warning(respuesta.mensaje);
        }

        this.spinnerService.hide();
      }
      );
  }

  esSolicitudPaga() {
    this.detalleInternoService.estaSolicitudPaga(this.detalle.idSolicitud, false)
      .subscribe(
      (data) => {
        this.solicitudPaga = data;
      },
      (error) => { this.alertaService.error('Error al validar la solicitud paga, por favor intente mas tarde.') }
      );
  }

  enviarCorreo() {
    this.spinnerService.show();

    this.detalleInternoService.enviarReporteHVPorEmail(this.detalle.idSolicitud)
      .subscribe(
      (data) => {
        if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
          this.alertaService.success(data.mensaje);
          this.actualizarInformacionAdicional(false);
        } else {
          this.alertaService.warning(data.mensaje);
        }
      },
      (error) => { this.alertaService.error('Error al enviar el Histórico del Conductor por correo electronico, por favor intente mas tarde.') }
      );
  }

  actualizarInformacionAdicional(mostrarMensaje: boolean) {
    if (mostrarMensaje) {
      this.spinnerService.show();
    }

    this.detalleInternoService.consultarInformacionAdicional(this.detalle.idSolicitud)
      .subscribe(
      (data) => {
        if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
          if (mostrarMensaje) {
            this.alertaService.success(data.mensaje);
          }
          this.detalle.informacionAdicional = data.object;

          this.esSolicitudPaga();

          this.spinnerService.hide();
        } else {
          this.alertaService.warning(data.mensaje);
        }
      },
      (error) => { this.alertaService.error('Error al validar la solicitud paga, por favor intente mas tarde.') }
      );
  }

  getMensajeLog(mensaje: string) {
    if (mensaje.length > 500) {
      return mensaje.substring(0, 500) + ' .....';
    }
    return mensaje;
  }

  async actualizarDetallePago() {

      try {
        let fechaNuevoPagoStr = await this.solicitudService.getParametros(Constantes.FECHA_NUEVO_PAGO).toPromise();
        const [diaNuevoPago, mesNuevoPago, anioNuevopago] = fechaNuevoPagoStr.split('/');
        let fechaNuevoPago = new Date(+anioNuevopago, +mesNuevoPago - 1, +diaNuevoPago);

        const [diaSolicitud, mesSolicitud, anioSolicitud] = this.detalle.fechaSolicitud.split('/');
        let fechaRegistroSolicitud =  new Date(+anioSolicitud, +mesSolicitud - 1, +diaSolicitud);

        if(fechaRegistroSolicitud < fechaNuevoPago){
          this.spinnerService.show();
          this.detalleInternoService.llamarServicioPsePorTransaccion(this.detalle.idSolicitud)
            .subscribe(
            (data) => {
              if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
                this.alertaService.success(data.mensaje);
                this.actualizarInformacionAdicional(false);
              } else {
                this.alertaService.warning(data.mensaje);
              }
            },
            (error) => { this.alertaService.error('Error al consultar la información de pse para la solicitud, por favor intente mas tarde.') }
            );
        } else {
          this.actualizarInformacionAdicional(false);
        }

      } catch (error) {
        this.alertaService.error('Error al consultar el prámetro, por favor intente mas tarde.')
      }
  }

  descargarCertificado() {
    this.spinnerService.show();

    this.detalleInternoService.getReporte(this.detalle.idSolicitud)
      .subscribe(
      (data) => {
        if (data) {
          this.spinnerService.hide();

          var file = new Blob([data], { type: 'application/pdf' });
          window.open(window.URL.createObjectURL(file));
        } else {
          this.alertaService.error('Error al descargar el certificado, por favor intente mas tarde.')
        }
      },
      (error: any) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 601) {
            this.alertaService.warning_noclose('En este momento se están presentando problemas de conexión al servicio de SIMIT, no es posible generar el certificado hasta que solicitante lo autorice.');
          } else {
            this.alertaService.error('Error al descargar el Histórico del Conductor, por favor intente mas tarde.');
          }
        }
      }
      );
  }

  cancelar() {
    this.autenticacionService.logout();

    this.router.navigate(['/consulta-runt']);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/core/components/detalle-runt/detalle-runt.component.ts